module.exports = __webpack_public_path__ + "assets/img/066101.edb6217b.svg";